import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import MetaPixel from './components/MetaPixel';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import MonsterPage from './pages/MonsterPage';
import WhyBuyPage from './pages/WhyBuyPage';
import FAQPage from './pages/FAQPage';
import LocationsPage from './pages/LocationsPage';
import ProcessPage from './pages/ProcessPage';
import CityPage from './pages/CityPage';
import HardwareComparisonPage from './pages/HardwareComparisonPage';
import UseCasesPage from './pages/UseCasesPage';
import BlogIndexPage from './pages/BlogIndexPage';
import SecureAITruths from './pages/blog/SecureAITruths';
import LocalAISquads from './pages/blog/LocalAISquads';
import MacBookFortress from './pages/blog/MacBookFortress';
import OpenClawAttribution from './pages/blog/OpenClawAttribution';
import HardwareShipping from './pages/blog/HardwareShipping';
import OriginStory from './pages/blog/OriginStory';
import CaughtDoingItRight from './pages/blog/CaughtDoingItRight';
import TailscaleSecureNetwork from './pages/blog/TailscaleSecureNetwork';
import SuccessPage from './pages/SuccessPage';
import PhaseDiscover from './pages/process/PhaseDiscover';
import PhaseStrategyCall from './pages/process/PhaseStrategyCall';
import PhaseBuild from './pages/process/PhaseBuild';
import PhaseDelivery from './pages/process/PhaseDelivery';
import PhaseActivation from './pages/process/PhaseActivation';
import PhaseSupport from './pages/process/PhaseSupport';
import AiEmailInfrastructure from './pages/blog/AiEmailInfrastructure';
import BmadAgentBuild from './pages/blog/BmadAgentBuild';
import DonaldHostileTakeover from './pages/blog/DonaldHostileTakeover';
import WhatRoofersThinkAI from './pages/blog/WhatRoofersThinkAI';
import TheBuildDossier from './pages/blog/TheBuildDossier';
import OpenClawGHL from './pages/blog/OpenClawGHL';
import OpenSourceExplained from './pages/blog/OpenSourceExplained';
import ProlineIntegration4Hours from './pages/blog/ProlineIntegration4Hours';
import QualityAssemblyLine from './pages/blog/QualityAssemblyLine';
import WhyNotCloud from './pages/blog/WhyNotCloud';
import CroAgent20Minutes from './pages/blog/CroAgent20Minutes';
import VitoBuiltIt from './pages/blog/VitoBuiltIt';
import AgentsTaughtMe from './pages/blog/AgentsTaughtMe';
import TheSeventyTwoHourWindow from './pages/blog/TheSeventyTwoHourWindow';
import LaborShortageParadox from './pages/blog/LaborShortageParadox';
import FourPercentProblem from './pages/blog/FourPercentProblem';
import SiteDownFixedInFive from './pages/blog/SiteDownFixedInFive';
import FiveMinuteRule from './pages/blog/FiveMinuteRule';
import AdminTax from './pages/blog/AdminTax';
import ClaudeDispatchVsRoofClaw from './pages/blog/ClaudeDispatchVsRoofClaw';
import ClaudeChromeExtensionVsRoofClaw from './pages/blog/ClaudeChromeExtensionVsRoofClaw';
import ClaudeMobileVsRoofClaw from './pages/blog/ClaudeMobileVsRoofClaw';
import RoofClawPlusWhatsNext from './pages/blog/RoofClawPlusWhatsNext';
import RoofClawVsHatch from './pages/blog/RoofClawVsHatch';
import RoofClawVsChiirp from './pages/blog/RoofClawVsChiirp';
import RoofClawVsAdminROI from './pages/blog/RoofClawVsAdminROI';
import RoofClawV2Launch from './pages/blog/RoofClawV2Launch';
import AiAdsRoofing from './pages/blog/AiAdsRoofing';
import ProlineSkill from './pages/blog/ProlineSkill';
import RoofClawLocalServiceAdAgent from './pages/blog/RoofClawLocalServiceAdAgent';
import HubspotGraphqlStormCampaign from './pages/blog/HubspotGraphqlStormCampaign';
import MetaAdsMcpHiggsfieldOpenClaw from './pages/blog/MetaAdsMcpHiggsfieldOpenClaw';
import AiGoogleLsaCallingOpenClaw from './pages/blog/AiGoogleLsaCallingOpenClaw';
import VitoPhoneLineBuild from './pages/blog/VitoPhoneLineBuild';
import AgentReadyBuildInPublic from './pages/blog/AgentReadyBuildInPublic';
import AdsPlaybook from './pages/AdsPlaybook';
import BrandKit from './pages/BrandKit';
import ProlineSkillPage from './pages/ProlineSkillPage';
import WinningWednesdayPage from './pages/WinningWednesdayPage';
import PortalLoginPage from './pages/PortalLoginPage';
import ScrollToTop from './components/ScrollToTop';
import ChatWidget from './components/chat/ChatWidget.jsx';
import InstantlyPixel from './components/InstantlyPixel.jsx';

// Portal Components
import PortalLayout from './pages/portal/PortalLayout';
import OnboardHub from './pages/portal/OnboardHub';
import IntakeForm from './pages/portal/IntakeForm';
import Credentials from './pages/portal/Credentials';
import BuildStatus from './pages/portal/BuildStatus';
import Support from './pages/portal/Support';

// Admin
import AdminDashboard from './pages/admin/AdminDashboard';
import ClientDetail from './pages/admin/ClientDetail';
import BuildBoard from './pages/admin/BuildBoard';
import BuildSheet from './pages/admin/BuildSheet';

// Paid Ads
import DemoPage from './pages/DemoPage';

// Chatbot
import ChatbotProposalPage from './pages/ChatbotProposalPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import PricingPage from './pages/PricingPage';
import ReadinessPage from './pages/ReadinessPage';
import BuildWelcomePage from './pages/BuildWelcomePage';
import TailscaleMethodPage from './pages/TailscaleMethodPage';

// Site-wide JSON-LD (Organization / Person / SoftwareApplication) is emitted
// directly from index.html so non-JS crawlers (Perplexity, OpenAI, Anthropic)
// see it on first byte. See projects/roofclaw-seo-2026-05/ for source.
const MainLayout = () => {
  return (
    <div className="min-h-screen font-heading bg-[#0A0A14] text-[#F0EFF4] selection:bg-[#7B61FF] selection:text-[#F0EFF4] flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <MetaPixel />
      <ScrollToTop />
      <ChatWidget />
      <InstantlyPixel />
      <Routes>
        {/* Main Public Website Layout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<MonsterPage />} />
          <Route path="/why" element={<WhyBuyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/readiness" element={<ReadinessPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/process/discover" element={<PhaseDiscover />} />
          <Route path="/process/strategy-call" element={<PhaseStrategyCall />} />
          <Route path="/process/build" element={<PhaseBuild />} />
          <Route path="/process/delivery" element={<PhaseDelivery />} />
          <Route path="/process/activation" element={<PhaseActivation />} />
          <Route path="/process/support" element={<PhaseSupport />} />
          <Route path="/locations/:cityId" element={<CityPage />} />
          <Route path="/hardware" element={<HardwareComparisonPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/tailscalemethod" element={<TailscaleMethodPage />} />
          <Route path="/talescalemethod" element={<TailscaleMethodPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/secure-ai-truths" element={<SecureAITruths />} />
          <Route path="/blog/local-ai-squads" element={<LocalAISquads />} />
          <Route path="/blog/macbook-fortress" element={<MacBookFortress />} />
          <Route path="/blog/openclaw-attribution" element={<OpenClawAttribution />} />
          <Route path="/blog/hardware-shipping" element={<HardwareShipping />} />
          <Route path="/blog/origin-story" element={<OriginStory />} />
          <Route path="/blog/caught-doing-it-right-email-automation-lesson" element={<CaughtDoingItRight />} />
          <Route path="/blog/tailscale-secure-network" element={<TailscaleSecureNetwork />} />
          <Route path="/blog/ai-email-infrastructure" element={<AiEmailInfrastructure />} />
          <Route path="/blog/bmad-agent-build" element={<BmadAgentBuild />} />
          <Route path="/blog/donald-hostile-takeover" element={<DonaldHostileTakeover />} />
          <Route path="/blog/what-roofers-think-ai" element={<WhatRoofersThinkAI />} />
          <Route path="/blog/the-build-dossier" element={<TheBuildDossier />} />
          <Route path="/blog/openclaw-ghl" element={<OpenClawGHL />} />
          <Route path="/blog/open-source-explained" element={<OpenSourceExplained />} />
          <Route path="/blog/proline-integration-4-hours" element={<ProlineIntegration4Hours />} />
          <Route path="/blog/quality-assembly-line" element={<QualityAssemblyLine />} />
          <Route path="/blog/why-not-cloud" element={<WhyNotCloud />} />
          <Route path="/blog/cro-agent-20-minutes" element={<CroAgent20Minutes />} />
          <Route path="/blog/vito-built-it" element={<VitoBuiltIt />} />
          <Route path="/blog/agents-taught-me-spikes" element={<AgentsTaughtMe />} />
          <Route path="/blog/the-72-hour-window" element={<TheSeventyTwoHourWindow />} />
          <Route path="/blog/site-down-fixed-in-five" element={<SiteDownFixedInFive />} />
          <Route path="/blog/labor-shortage-paradox" element={<LaborShortageParadox />} />
          <Route path="/blog/four-percent-problem" element={<FourPercentProblem />} />
          <Route path="/blog/five-minute-rule" element={<FiveMinuteRule />} />
          <Route path="/blog/admin-tax" element={<AdminTax />} />
          <Route path="/blog/claude-dispatch-vs-roofclaw" element={<ClaudeDispatchVsRoofClaw />} />
          <Route path="/blog/claude-chrome-extension-vs-roofclaw" element={<ClaudeChromeExtensionVsRoofClaw />} />
          <Route path="/blog/claude-mobile-vs-roofclaw" element={<ClaudeMobileVsRoofClaw />} />
          <Route path="/blog/roofclaw-plus-whats-next" element={<RoofClawPlusWhatsNext />} />
          <Route path="/blog/roofclaw-vs-hatch-receptionist-vs-chief-of-staff" element={<RoofClawVsHatch />} />
          <Route path="/blog/roofclaw-vs-chiirp-what-voice-ai-cant-do" element={<RoofClawVsChiirp />} />
          <Route path="/blog/roofclaw-vs-admin-roi-math" element={<RoofClawVsAdminROI />} />
          <Route path="/blog/roofclaw-v2-launch" element={<RoofClawV2Launch />} />
          <Route path="/blog/ai-ads-roofing-playbook" element={<AiAdsRoofing />} />
          <Route path="/blog/proline-claw-skill" element={<ProlineSkill />} />
          <Route path="/blog/roofclaw-local-service-ad-agent" element={<RoofClawLocalServiceAdAgent />} />
          <Route path="/blog/hubspot-graphql-storm-campaign" element={<HubspotGraphqlStormCampaign />} />
          <Route path="/blog/meta-ads-mcp-higgsfield-openclaw" element={<MetaAdsMcpHiggsfieldOpenClaw />} />
          <Route path="/blog/how-to-use-ai-to-automate-calling-google-local-services-leads-openclaw" element={<AiGoogleLsaCallingOpenClaw />} />
          <Route path="/blog/vito-phone-line-livestream-build" element={<VitoPhoneLineBuild />} />
          <Route path="/blog/agent-ready-build-in-public" element={<AgentReadyBuildInPublic />} />
          <Route path="/ads-playbook" element={<AdsPlaybook />} />
          <Route path="/brand-kit" element={<BrandKit />} />
          <Route path="/proline-skill" element={<ProlineSkillPage />} />
            <Route path="/success" element={<SuccessPage />} />
          <Route path="/winning-wednesday" element={<WinningWednesdayPage />} />
          <Route path="/portal" element={<PortalLoginPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Route>

        {/* Secure Tokenized Portal Layout */}
        <Route path="/onboard/:token" element={<PortalLayout />}>
          <Route index element={<OnboardHub />} />
          <Route path="intake" element={<IntakeForm />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="status" element={<BuildStatus />} />
          <Route path="support" element={<Support />} />
        </Route>

        {/* /demo — Paid Ad Conversion Page (no nav/footer) */}
        <Route path="/demo" element={<DemoPage />} />

        {/* /build/welcome — hidden post-session confirmation (no nav/footer) */}
        <Route path="/build/welcome" element={<BuildWelcomePage />} />

        {/* /chatbot/proposal — Proposal page for qualified chatbot prospects */}
        <Route path="/chatbot/proposal" element={<ChatbotProposalPage />} />

        {/* Admin Dashboard */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/client/:clientId" element={<ClientDetail />} />
        <Route path="/admin/build" element={<BuildBoard />} />
        <Route path="/admin/build/:id" element={<BuildSheet />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
